(function () {
  var header = document.querySelector('.oddit-header');
  if (!header) return;

  // Mega menu
  var megaTriggers = header.querySelectorAll('[data-mega-menu-trigger]');
  var megaPanels = header.querySelectorAll('[data-mega-menu-panel]');
  var overlay = header.querySelector('[data-mega-menu-overlay]');
  var closeTimer = null;

  function openMega(label) {
    clearTimeout(closeTimer);
    for (var i = 0; i < megaPanels.length; i++) {
      var match = megaPanels[i].getAttribute('data-mega-menu-label') === label;
      megaPanels[i].classList.toggle('is-open', match);
      megaPanels[i].setAttribute('aria-hidden', match ? 'false' : 'true');
    }
    for (var j = 0; j < megaTriggers.length; j++) {
      megaTriggers[j].setAttribute(
        'aria-expanded',
        megaTriggers[j].getAttribute('data-mega-menu-label') === label ? 'true' : 'false'
      );
    }
    if (overlay) overlay.classList.add('is-visible');
  }

  function closeMega() {
    for (var i = 0; i < megaPanels.length; i++) {
      megaPanels[i].classList.remove('is-open');
      megaPanels[i].setAttribute('aria-hidden', 'true');
    }
    for (var j = 0; j < megaTriggers.length; j++) {
      megaTriggers[j].setAttribute('aria-expanded', 'false');
    }
    if (overlay) overlay.classList.remove('is-visible');
  }

  function scheduleClose() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(closeMega, 180);
  }

  function isHoverPointer(e) {
    return e.pointerType === 'mouse' || e.pointerType === 'pen';
  }

  for (var t = 0; t < megaTriggers.length; t++) {
    (function (trigger) {
      var wrapper = trigger.closest('.oddit-header__nav-item') || trigger.parentElement;

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        var open = trigger.getAttribute('aria-expanded') === 'true';
        if (open) closeMega();
        else openMega(trigger.getAttribute('data-mega-menu-label'));
      });

      if (wrapper) {
        wrapper.addEventListener('pointerenter', function (e) {
          if (!isHoverPointer(e)) return;
          openMega(trigger.getAttribute('data-mega-menu-label'));
        });
        wrapper.addEventListener('pointerleave', function (e) {
          if (!isHoverPointer(e)) return;
          scheduleClose();
        });
      }
    })(megaTriggers[t]);
  }

  for (var p = 0; p < megaPanels.length; p++) {
    megaPanels[p].addEventListener('pointerenter', function (e) {
      if (!isHoverPointer(e)) return;
      clearTimeout(closeTimer);
    });
    megaPanels[p].addEventListener('pointerleave', function (e) {
      if (!isHoverPointer(e)) return;
      scheduleClose();
    });
  }

  if (overlay) overlay.addEventListener('click', closeMega);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMega();
  });

  // Mobile drawer
  var mobileToggle = header.querySelector('[data-mobile-menu-toggle]');
  var mobileClose = header.querySelector('[data-mobile-menu-close]');
  var mobileDrawer = header.querySelector('[data-mobile-drawer]');

  /**
   * The drawer opens below the live nav bar — announcement bar included, since
   * the nav sits under it. Both scroll with the page, so this shrinks to 0 once
   * they have scrolled away.
   */
  function updateDrawerOffset() {
    if (!mobileDrawer) return;
    var bar = header.querySelector('.oddit-header__nav');
    var offset = 0;
    if (bar) {
      offset = Math.max(0, bar.getBoundingClientRect().bottom);
    }
    mobileDrawer.style.setProperty('--oddit-drawer-top', offset + 'px');
  }

  function openDrawer() {
    if (!mobileDrawer) return;
    updateDrawerOffset();
    mobileDrawer.classList.add('is-open');
    mobileDrawer.setAttribute('aria-hidden', 'false');
    if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'true');
    document.body.classList.add('oddit-header-menu-open');
  }

  function closeDrawer() {
    if (!mobileDrawer) return;
    mobileDrawer.classList.remove('is-open');
    mobileDrawer.setAttribute('aria-hidden', 'true');
    if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('oddit-header-menu-open');
  }

  /* The nav's hamburger is also the drawer's close button — the drawer has no
     top bar of its own, it opens below the live nav bar. */
  if (mobileToggle) {
    mobileToggle.addEventListener('click', function () {
      if (mobileDrawer && mobileDrawer.classList.contains('is-open')) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });
  }
  if (mobileClose) mobileClose.addEventListener('click', closeDrawer);

  window.addEventListener('resize', function () {
    if (mobileDrawer && mobileDrawer.classList.contains('is-open')) {
      updateDrawerOffset();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  // Cart drawer
  var cartToggles = header.querySelectorAll('[data-cart-toggle]');
  for (var i = 0; i < cartToggles.length; i++) {
    cartToggles[i].addEventListener('click', function () {
      if (window.OdditCartDrawer) {
        window.OdditCartDrawer.open();
      }
    });
  }

  document.addEventListener('cart:updated', function (e) {
    var cart = e.detail.cart;
    var badges = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = cart.item_count;
      badges[i].style.display = cart.item_count > 0 ? '' : 'none';
    }
  });
})();